import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { Observable } from 'rxjs';

@Injectable()
export class SettingsService {
  constructor(private http: ApiClient) {}

  registerStripeConfiguration(credentials) {
    return this.http.post('settings/connect-stripe', credentials);
  }

  getStripeStatus() {
    return this.http.get('settings/stripe-status');
  }

  getXeroConnectionUrl() {
    return this.http.get('settings/xero/connect-url');
  }

  getXeroStatus() {
    return this.http.get('settings/xero/status');
  }

  registerXeroConfiguration(token, verifier, organisation) {
    return this.http.post('settings/xero/register', {
      token,
      verifier,
      organisation
    });
  }

  disconnectXero() {
    return this.http.get('settings/xero/disconnect');
  }

  exportProducts() {
    return this.http.get('settings/export-products', {
      responseType: 'blob'
    });
  }

  importProducts(file: File): Observable<{
    categories?: {
      created: number;
      updated: number;
    };
    products?: {
      created: number;
      updated: number;
    };
    items?: {
      created: number;
      updated: number;
    };
  }> {
    const formData = new FormData();
    formData.append('product_data', file);
    return this.http.post('settings/import-products', formData);
  }
}
